import { NAMESPACE } from 'locale'
import { toDosConstants } from 'locale/toDos'
import { useTranslation } from 'react-i18next'
import TextArea from '@lmc/ui-kit/src/dataEntry/Input/components/TextArea/TextArea'
import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'
import { requiredContent } from 'screens/Residents/screens/ResidentsGoalsScreen/components/FormItem/CategoryInfo'

type CommentSectionProps = {
  onChange?: (value: string) => void
  required: boolean
}

export const ITEM_NAME = 'comment'

const CommentSection = ({ onChange, required }: CommentSectionProps) => {
  const { t } = useTranslation(NAMESPACE.TODOS)

  return (
    <CommentContainer>
      <StatusModalText required={required} weight="bold">
        {t(toDosConstants.ADD_COMMENT)}
      </StatusModalText>
      <StyledTextArea
        autoSize={{ minRows: 4 }}
        placeholder={t(toDosConstants.TEXT_AREA_PLACEHOLDER)}
        onChange={(e) => onChange?.(e.target.value)}
      />
    </CommentContainer>
  )
}

const StatusModalText = styled(Text)<{ required: boolean }>`
  color: ${(props) => props.theme.color.neutral.color3};

  ${(props) => props.required && requiredContent}
`

const CommentContainer = styled.div`
  margin-bottom: 24px;
`

const StyledTextArea = styled(TextArea)`
  margin-top: 8px;
`
export default CommentSection
